<app-header></app-header>
<div class="content content-list px-3 pb-7">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h1 class="bigger d-flex align-items-center">
          <img
            src="assets/img/img-patient-list.svg"
            class="img-fluid mx-5 patient-avatar d-none d-md-inline-block"
            alt="avatar"
          />
          <span i18n="@@patient_patientList_patientListTitle">
            Patient List
          </span>
        </h1>
      </div>
    </div>
    <div class="row mt-7">
      <div class="col-12">
        <div class="search-bar position-relative">
          <form [formGroup]="searchListPatientsForm">
            <div class="search-bar-group">
              <input
                #search
                class="search-bar-input form-control"
                formControlName="search"
                placeholder="Search for a patient by name"
                i18n-placeholder="
                  @@patient_patientList_patientListSearchPlaceholder"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 py-3">
        <ng-container>
          <div class="table-responsive">
            <table class="table table-hover table-list">
              <thead>
                <tr>
                  <th appSortable="lastName" (sort)="onSort($event)">
                    <span i18n="@@patient_patientList_patientListLastName">
                      Last name
                    </span>
                  </th>
                  <th appSortable="firstName" (sort)="onSort($event)">
                    <span i18n="@@patient_patientList_patientListFirstName">
                      First name
                    </span>
                  </th>
                  <th
                    appSortable="birthDate"
                    (sort)="onSort($event)"
                    class="text-center"
                  >
                    <span i18n="@@patient_patientList_patientListBirthday">
                      Birthday
                    </span>
                  </th>
                  <th
                    appSortable="gender"
                    (sort)="onSort($event)"
                    class="text-center"
                  >
                    <span i18n="@@patient_patientList_patientListGender">
                      Gender
                    </span>
                  </th>
                  <th
                    appSortable="pairing"
                    (sort)="onSort($event)"
                    class="text-center"
                  >
                    <span i18n="@@patient_patientList_patientListActions">
                      Actions
                    </span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-template #noPatients>
                  <tr>
                    <td colspan="6" class="bg-white">
                      <div class="py-8">
                        <div
                          class="py-7 d-flex justify-content-center text-center"
                        >
                          <div>
                            <img
                              src="assets/img/empty-patient-list.svg"
                              class="img-fluid"
                              alt="No patient"
                            />
                            <p
                              *ngIf="!noPatientFound; else noFoundPatients"
                              class="text-primary mt-5 fs-5 mb-0"
                              i18n="@@patient_patientList_patientListWait"
                            >
                              let's wait for your first patients
                            </p>
                            <ng-template #noFoundPatients>
                              <p
                                class="text-primary mt-5 fs-5 mb-0"
                                i18n="@@patient_patientList_patientListNotFound"
                              >
                                no found patient
                              </p>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-container
                  *ngIf="
                    patients.length > 0 && patients.length > 0;
                    else noPatients
                  "
                >
                  <tr *ngFor="let patient of patients; let i = index">
                    <td class="bg-white">
                      <ng-container *appSkeletonLoader="loading">
                        {{ patient.lastName }}
                      </ng-container>
                    </td>
                    <td class="bg-white">
                      <ng-container *appSkeletonLoader="loading">
                        {{ patient.firstName }}
                      </ng-container>
                    </td>
                    <td class="text-center bg-white">
                      <ng-container *appSkeletonLoader="loading">
                        {{ patient.birthDate | date : formatDate }}
                      </ng-container>
                    </td>
                    <td class="text-center bg-white">
                      <ng-container
                        *appSkeletonLoader="loading; type: 'square'"
                      >
                        {{ genderMapping[patient.gender] }}
                      </ng-container>
                    </td>
                    <td class="text-center bg-white">
                      <ng-container *appSkeletonLoader="loading">
                        <a
                          *ngIf="
                            patient.pairing.relationType ===
                              relationType.ACCEPTED;
                            else noPairing
                          "
                          [routerLink]="['detail', patient.getId()]"
                          class="btn btn-outline-primary action-btn m-auto"
                        >
                          <img
                            src="assets/icons/icon_folder.svg"
                            alt="folder"
                          />
                          <span
                            class="flex-fill text-center text-uppercase"
                            i18n="@@patient_patientList_patientListSeeFile"
                            >See the file</span
                          >
                        </a>
                        <ng-template #noPairing>
                          <button
                            type="button"
                            (click)="openPairingPatientModal(patient.getId())"
                            class="btn btn-primary action-btn m-auto"
                          >
                            <img
                              src="assets/icons/icon_pairing.svg"
                              alt="pairing"
                            />
                            <span
                              class="flex-fill text-center text-uppercase"
                              i18n="@@patient_patientList_patientListPairing"
                              >Pairing</span
                            >
                          </button>
                        </ng-template>
                      </ng-container>
                    </td>
                    <td class="actions text-end bg-white">
                      <ng-container
                        *appSkeletonLoader="loading; type: 'square'"
                      >
                        <button
                          type="button"
                          (click)="openUnpairingPatientModal(patient.getId())"
                          class="btn p-0 float-end text-light border-0"
                          title="Unpairing"
                        >
                          <img
                            src="assets/icons/icon_trash.svg"
                            alt="decline"
                          />
                        </button>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <app-pagination
          *ngIf="totalPages > 1"
          [currentPage]="page"
          [totalPages]="totalPages"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>
